<template>
  <article class="register-principal_container" :class="{ 'is-success': success }">
    <loader v-if="isLoading"></loader>
    <div v-if="!success" class="register-page">
      <!-- Header -->
      <header class="register-header">
        <fuseaccess-logo class="register-logo"></fuseaccess-logo>
      </header>

      <!-- Content -->
      <section v-if="!validate" class="register-content">
        <h2>Ahora registraremos tu usuario</h2>
        <div class="register-form-section">
          <label>Ingresar No. de identificación</label>
          <input type="text" id="identification" v-model="identification" placeholder="Escribe tu número de Cédula" />
        </div>
      </section>

      <section v-if="validate" class="register-content">
        <h2>Finalizaremos con tu contraseña</h2>
        <div class="register-form-section">
          <label>Ingresa tu contraseña </label>
          <div class="register-password-container">
            <input  :type="showPassword ? 'text' : 'password'"  v-model="password" placeholder="Escribe tu contraseña"
              :class="{ 'register-error': passwordError }" @blur="validatePasswords" />
            <img src="../assets/img/icons/visibility.svg" alt="Mostrar/Ocultar contraseña"
            @click="showPassword=!showPassword"
             />
          </div>

          <p v-if="passwordError" class="register-error-text">
            {{ correction_message }}
          </p>
          <br><br>
          <div class="register-password-container">

          <input :type="showConfirmPassword ? 'text' : 'password'" v-model="password_confirmation" placeholder="Confirma tu contraseña"
            :class="{ 'register-error': passwordMatchError }" @blur="validateMatch" />
            <img src="../assets/img/icons/visibility.svg" alt="Mostrar/Ocultar contraseña"
            @click="showConfirmPassword=!showConfirmPassword"
           />
          </div>
          <p v-if="passwordMatchError" class="register-error-text">
            Las contraseñas no coinciden
          </p>
          <br>

          <label>Ingresa PIN de seguridad </label>
          <div class="register-pin-container">
            <div class="register-pin-box" v-for="(digit, index) in pin.length" :key="index">
              <input type="tel" v-model="pin[index]" maxlength="1" placeholder="0" pattern="[0-9]*" inputmode="numeric"
                @input="handleInput(index)" @keydown.backspace="handleBackspace(index)" ref="pinInputs"
                @keypress="onlyNumbers($event)" />
            </div>
          </div>
        </div>
      </section>

      <!-- Footer -->
      <footer class="register-footer">
        <div class="register-footer-space">
          <span class="register-footer-logo"><fuseaccess-logo></fuseaccess-logo></span>
        </div>
        <button v-if="!validate" @click="validateUser">Continuar</button>
        <button v-if="validate" @click="registerUser">Finalizar</button>
      </footer>

    </div>
    <div v-if="success">
      <div class="container">
        <div class="table_card">
          <div class="table_card__head">
            <register-icon></register-icon>
            <p class="table_card__head--title">
              Actualización Completada
            </p>
          </div>
          <div class="table_card__body">
            Has finalizado satisfactoriamente el proceso de registro,
            ahora puedes ingresar en la aplicación móvil con la nueva contraseña que acabas de asignar.
          </div>
          <div class="table_card__footer">
            <p>Ya puedes cerrar esta pestaña en tu navegador.</p>
          </div>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
import FuseaccessLogo from "/src/components/shared/icons/FuseaccessLogo.vue";
import RegisterIcon from "./shared/icons/RegisterIcon.vue";
import Loader from "./shared/Loader.vue";
export default {
  components: {
    FuseaccessLogo,
    RegisterIcon,
    Loader,
  },
  data() {
    return {
      user_id: null,
      identification: "",
      validate: false,
      pin: ["", "", "", ""],
      password: "",
      password_confirmation: "",
      passwordMatchError: false,
      device_id: null,
      passwordError: false,
      correction_message: null,
      success: false,
      showPassword:false,
      showConfirmPassword: false,
      isLoading: false,
    };
  },
  mounted() {
    // Leer parámetros de la URL al montar el componente
    const params = this.$route.query;
    this.device_id = localStorage.device_id;
    console.log("Parámetros recibidos:", params);
  },
  methods: {
    async validateUser() {
      if (this.identification.trim() === "") {
        alert("Por favor ingrese su número de identificación.");
        return;
      }

      const params = this.$route.query;
      const mobile = params.mobile ? params.mobile : null;
      const email = params.email ? params.email : null;

      // if (!mobile) {
      //   alert("El enlace no es valido.");
      //   return;
      // }
      const verify_code = params.verify_code || params.password

      this.isLoading = true;

      const isValidUser = await this.validateDataImportUsers(
        mobile,
        verify_code,
        this.identification,
        params.company_id,
        email
      );

      if (!isValidUser) {
        this.isLoading = false;
        alert("El enlace no es valido.");
        
        return;
      }

      await this.validateUserCredentials(
        params.email,
        this.identification,
        params.company_id
      );
      this.isLoading = false;
    },
    async registerUser() {
      if (this.password !== this.password_confirmation) {
        this.passwordMatchError = true;
        return;
      }
      const pinNumber = parseInt(this.pin.join(""), 10);
      this.isLoading = true;

      const save = await this.saveData(
        this.user_id,
        this.password,
        this.password_confirmation,
        pinNumber
      );
      this.isLoading = false;
    },

    isValidPassword(password) {
      if (!password) {
        this.correction_message = "La contraseña no puede estar vacía.";
        return false;
      }
      if (password.length < 6) {
        this.correction_message =
          "La contraseña debe tener al menos 6 caracteres.";
        return false;
      }
      // if (!/[A-Z]/.test(password)) {
      //   this.correction_message =
      //     "La contraseña debe contener al menos una letra mayúscula.";
      //   return false;
      // }
      // if (!/[a-z]/.test(password)) {
      //   this.correction_message =
      //     "La contraseña debe contener al menos una letra minúscula.";
      //   return false;
      // }
      // if (!/\d/.test(password)) {
      //   this.correction_message =
      //     "La contraseña debe contener al menos un número.";
      //   return false;
      // }

      this.correction_message = "";
      return true;
    },

    validatePasswords() {
      this.passwordError = !this.isValidPassword(this.password);
    },
    validateMatch() {
      this.passwordMatchError = this.password !== this.password_confirmation;
    },
    handleInput(index) {
      if (this.pin[index] && index < this.pin.length - 1) {
        this.$nextTick(() => {
          if (this.pin[index + 1]) {
            this.pin[index + 1] = ""; // Vacía el siguiente input si ya tiene un valor
          }
          this.$refs.pinInputs[index + 1].focus();
        });
      }
    }
    ,
    handleBackspace(index) {
      if (!this.pin[index] && index > 0) {
        this.$refs.pinInputs[index - 1].focus();
      }
    },
    async saveData(user_id, password, password_confirmation, access_pin) {
      console.log("saveData");

      const data = {
        user_id,
        password,
        password_confirmation,
        access_pin,
      };

      try {
        const response = await this.$http.post(
          "users/save_user_data",
          { data: this.encrypt(data).toString() },
          {
            headers: {
              "X-Device-ID": this.device_id,
              Authorization: `Bearer ${this.token}`,
            },
          }
        );

        const { meta } = response.body || {};
        if (response.body.ans === "Registro Completado Exitosamente.") {
          this.success = true; // Asignar éxito
        }
      } catch (error) {
        if (error.response?.status === 402) {
          alert(
            "Ha excedido el número máximo de intentos de inicio de sesión. Por favor, intente más tarde."
          );
        } else {
          console.error("Error en saveData:", error);
          alert(" Error cargando la información")
        }
      }
    },
    async validateUserCredentials(email, password, company_id) {

      const data = {
        attributes: { email, password, company: company_id },
      };
      console.log(data);

      try {
        const response = await this.$http.post(
          "users/sign_in",
          { data: this.encrypt(data).toString() },
          { headers: { "X-Device-ID": this.device_id } }
        );
        console.log(response)
        const { meta, data: userData } = response.body || {};

        if (meta?.authentication_token) {
          console.log(meta)
          this.token = meta.authentication_token;
          this.validate = true;
        }

        if (response.status === 201 && userData) {
          console.log(userData)
          this.user_id = userData.id;
        } else {
          alert("Falla en la autenticación");
        }
      } catch (error) {
        console.error("Error en la autenticación:", error);
      }
    },

    async validateDataImportUsers(mobile, verify_code, rut, company, email) {
      console.log("validateDataImportUsers");

      const data = {
        mobile: mobile,
        verify_code: verify_code,
        rut: rut,
        company: company,
        email: email
      };
      console.log(data);

      try {
        const response = await this.$http.get(
          "app/users/validate_data_import_users",
          { params: { data: data } }
        );

        if (response.status === 200) {
          console.log("Usuario validado correctamente");
          return true;
        } else {
          console.warn("Falla en la validación del usuario");
          return false;
        }
      } catch (error) {
        console.error("Error en validateDataImportUsers:", error);
        return false;
      }
    },
    onlyNumbers(event) {
      if (!/^\d$/.test(event.key)) {
        event.preventDefault();
      }
    },
  },
};
</script>
